<template>
  <van-list
    :is-loading.sync="loading"
    :finished="loaded"
    :finished-text="$t('没有更多数据')"
    @load="() => $emit('load')"
  >
    <slot />
  </van-list>
</template>

<script>
export default {
  name: 'AppList',
  props: {
    loaded: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/AppTmpl/AppList.vue